import React, { useState } from 'react'
import './Header.css'

import logo from '../Media/logo.png';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
// Info row icons
import EventNoteIcon from '@material-ui/icons/EventNote';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import StorefrontIcon from '@material-ui/icons/Storefront';
import HomeIcon from '@material-ui/icons/Home';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { signout } from '../Actions/userActions';
import { useSearch } from '../Context/SearchContext';
import { firebaseAuth, firestore } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot, collection } from 'firebase/firestore';
import { useHistory } from "react-router-dom";





function Header() {

    const cart = useSelector(state => state.cart);
    const{ cartItems } = cart;
    
    const userSignin = useSelector((state) => state.userSignin);
    const { userInfo } = userSignin;

    const { searchQuery, updateSearchQuery } = useSearch();

    const dispatch = useDispatch();
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [profileImageError, setProfileImageError] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [wishlistCount, setWishlistCount] = useState(0);
    const [notifCount, setNotifCount] = useState(0);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const history = useHistory();
    const signoutHandler = () =>{
        setShowProfileDropdown(false);
        dispatch(signout());
    }

    // Close dropdown when clicking outside
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (showProfileDropdown && !event.target.closest('.profile-dropdown-container')) {
                setShowProfileDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showProfileDropdown]);

    // Live counters for cart, wishlist, notifications from Firestore
    React.useEffect(() => {
        // Small delay to ensure authentication state is loaded
        const setupListeners = () => {
            const uid = (firebaseAuth.currentUser && firebaseAuth.currentUser.uid) || userInfo?.uid;
            let unsubCart;
            let unsubWishlist;
            let unsubNotif;
            if (!uid) {
                setCartCount(0);
                setWishlistCount(0);
                setNotifCount(0);
                console.log('No UID available for listeners - User not authenticated');
                return () => {};
            }
            console.log('Setting up Firestore listeners for UID:', uid);
            try {
                // Cart count from doc list_size
                unsubCart = onSnapshot(doc(firestore, 'USERS', uid, 'USER_DATA', 'MY_CART'), (snap) => {
                    const d = snap.data() || {};
                    let size = Number(d.list_size) || 0;
                    if (!size) {
                        // fallback: count product_ID_* keys if present
                        size = Object.keys(d).filter(k => k.startsWith('product_ID_')).length;
                    }
                    console.log('Cart count updated:', size, 'Document data keys:', Object.keys(d));
                    setCartCount(size);
                }, (error) => {
                    console.error('Cart listener error:', error);
                    setCartCount(0);
                });
            } catch (error) {
                console.error('Cart listener setup error:', error);
                setCartCount(0);
            }
            try {
                // Wishlist count from doc list_size
                unsubWishlist = onSnapshot(doc(firestore, 'USERS', uid, 'USER_DATA', 'MY_WISHLIST'), (snap) => {
                    const d = snap.data() || {};
                    let size = Number(d.list_size) || 0;
                    if (!size) size = Object.keys(d).filter(k => k.startsWith('product_ID_')).length;
                    console.log('Wishlist count updated:', size, 'Document data:', d);
                    setWishlistCount(size);
                }, (error) => {
                    console.error('Wishlist listener error:', error);
                    setWishlistCount(0);
                });
            } catch (error) {
                console.error('Wishlist listener setup error:', error);
                setWishlistCount(0);
            }
            try {
                // Notifications - MY_NOTIFICATIONS is a document, not a collection
                const notificationsDocRef = doc(firestore, 'USERS', uid, 'USER_DATA', 'MY_NOTIFICATIONS');

                // Listen to the document directly
                unsubNotif = onSnapshot(notificationsDocRef, (snap) => {
                    const d = snap.data() || {};
                    const size = Number(d.list_size) || 0;
                    // If backend provides a direct unread_count, prefer it
                    if (typeof d.unread_count === 'number' && d.unread_count >= 0) {
                        setNotifCount(d.unread_count);
                        return;
                    }
                    // Otherwise compute unread by scanning flags; support both readed_i and Readed_i
                    let unread = 0;
                    if (size > 0) {
                        for (let i = 0; i < size; i++) {
                            const r1 = d.hasOwnProperty(`readed_${i}`) ? !!d[`readed_${i}`] : undefined;
                            const r2 = d.hasOwnProperty(`Readed_${i}`) ? !!d[`Readed_${i}`] : undefined;
                            const isRead = (r1 !== undefined ? r1 : (r2 !== undefined ? r2 : false));
                            if (!isRead) unread++;
                        }
                    }
                    // Fallback: if no flags present at all, use size as unread
                    if (unread === 0) {
                        const anyFlag = Object.keys(d).some(k => /^(readed|Readed)_\d+$/.test(k));
                        if (!anyFlag) unread = size;
                    }
                    console.log('Notifications unread computed:', unread, 'of total', size);
                    setNotifCount(unread);
                }, (error) => {
                    console.error('Notifications listener error:', error);
                    setNotifCount(0);
                });
            } catch (error) {
                console.error('Notifications setup error:', error);
                setNotifCount(0);
            }    
            return () => {
                console.log('Cleaning up Firestore listeners');
                if (typeof unsubCart === 'function') unsubCart();
                if (typeof unsubWishlist === 'function') unsubWishlist();
                if (typeof unsubNotif === 'function') unsubNotif();
            };
        };

        // Initial setup
        const cleanup = setupListeners();

        // Also listen for auth state changes with a small delay to ensure persistence
        const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
            console.log('Auth state changed:', user ? 'User signed in' : 'User signed out');
            if (cleanup && typeof cleanup === 'function') {
                cleanup(); // Clean up old listeners
            }
            // Small delay to ensure auth state is fully loaded
            setTimeout(() => {
                setupListeners();
            }, 100);
        });

        return () => {
            if (cleanup && typeof cleanup === 'function') cleanup();
            unsubscribe();
        };
    }, [userInfo?.uid, refreshTrigger]);

    // If Firebase auth becomes null but Redux still has userInfo (e.g., account deleted), force signout

    // Global function to refresh header counts (for other components to call)
    React.useEffect(() => {
        window.refreshHeaderCounts = () => {
            setRefreshTrigger(prev => prev + 1);
        };

        return () => {
            delete window.refreshHeaderCounts;
        };
    }, []);

    React.useEffect(() => {
        const doReload = async () => {
            try {
                if (firebaseAuth.currentUser) {
                    await firebaseAuth.currentUser.reload();
                }
            } catch (error) {
                console.error('Auth reload error:', error);
                // If reload fails due to auth issues, sign out
                if (error.code === 'auth/user-token-expired' || error.code === 'auth/user-disabled') {
                    dispatch(signout());
                }
            }
        };
        // Initial reload on mount if signed in
        if (userInfo) {
            doReload();
        }
    }, [dispatch, userInfo]);

    const handleSearchChange = (e) => {
        updateSearchQuery(e.target.value);
    }

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        // Search is handled by the context, no need to do anything here
    }
    
    return (
        <div className='header'>
            {/* Left Section - Logo */}
            <div className="header__left">
                <Link to="/">
                    <img className='header__logo' src={logo} alt="logo" />
                </Link>
            </div>

            {/* Center Section - Search */}
            <div className="header__center">
                <div className="header__search">
                    <form onSubmit={handleSearchSubmit}>
                        <input
                            className='header__searchInput' 
                            type="text"
                            placeholder="Search products by title, tags, brand..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                        <SearchIcon
                            className='header__searchIcon' />
                    </form>
                </div>
            </div>

            {/* Right Section - Cart and User */}
            <div className="header__right">
                {/* Cart */}
                <div className='header__option header__cart'>
                    <span className='header__optionLineOne header__basketCount'>
                        <span className="badge">{
                            (() => {
                                const live = (typeof cartCount === 'number') ? cartCount : undefined;
                                const fallback = Array.isArray(cartItems) ? cartItems.length : 0;
                                return Math.max(0, (live !== undefined ? live : fallback));
                            })()
                        }</span>
                    </span>
                    <span className='header__optionLineTwo'>
                        <Link to="/cart"><ShoppingCartIcon /></Link>
                    </span>
                </div>

                {/* Wishlist */}
                <div className='header__option header__wishlist'>
                    <span className='header__optionLineOne header__wishlistCount'>
                        <span className="badge">{Math.max(0, wishlistCount || 0)}</span>
                    </span>
                    <span className='header__optionLineTwo'>
                        <Link to="/wishlist"><FavoriteBorderIcon /></Link>
                    </span>
                </div>

                {/* Notifications */}
                <div className='header__option header__notifications'>
                    <span className='header__optionLineOne header__notificationsCount'>
                        <span className="badge">{Math.max(0, notifCount || 0)}</span>
                    </span>
                    <span className='header__optionLineTwo'>
                        <Link to="/notifications"><NotificationsNoneIcon /></Link>
                    </span>
                </div>

                {/* Become Seller */}
                <div className='header__option header__becomeSeller'>
                    <span className='header__optionLineTwo'>
                        <a
                            href="https://seller.shopiebazar.com"
                            target="_blank"
                            rel="noreferrer"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none', color: 'inherit', fontWeight: 600 }}
                        >
                            <StorefrontIcon style={{ fontSize: 18 }} />
                            <span>Become Seller</span>
                        </a>
                    </span>
                </div>

                {/* User Authentication */}
                <div className='header__option header__auth'>
                    {
                        userInfo ? (
                            <div className="profile-dropdown-container">
                                <div 
                                    className="profile-trigger" 
                                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                                >
                                    {userInfo.Profile && userInfo.Profile !== "" && !profileImageError ? (
                                        <img 
                                            className="profile-avatar-header"
                                            src={userInfo.Profile}
                                            alt={userInfo.Full_Name || 'User'}
                                            onError={() => setProfileImageError(true)}
                                        />
                                    ) : (
                                        <div className="profile-avatar-header-fallback">
                                            {(userInfo.Full_Name || userInfo.email || 'U').charAt(0).toUpperCase()}
                                        </div>
                                    )}
                                    <span className="profile-name-header">{userInfo.Full_Name || userInfo.email?.split('@')[0] || 'User'}</span>
                                    <i className="fa fa-caret-down"></i>
                                </div>
                                
                                {showProfileDropdown && (
                                    <div className="profile-dropdown">
                                        <div className="profile-dropdown-header">
                                            <div className="profile-header-title">
                                                <span>User Profile</span>
                                                <div className="profile-header-actions">
                                                    {/* <Link to="/profile"> */}
                                                        <button className="profile-header-btn" title="View & Edit Profile" onClick={() => history.push("/profile")}>
                                                            <AccountCircleIcon style={{fontSize: 18}} />
                                                        </button>
                                                    {/* </Link> */}
                                                    <button className="profile-header-btn logout-btn" onClick={signoutHandler} title="Logout">
                                                        <i className="fa fa-sign-out" style={{fontSize: 16}}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="profile-dropdown-divider"></div>
                                        
                                        <div className="profile-main-info" style={{padding:'16px'}}>
                                            {/* User Info Row */}
                                            <div style={{display:'flex', alignItems:'center', gap:10, marginBottom:10}}>
                                                {userInfo.Profile && userInfo.Profile !== "" && !profileImageError ? (
                                                    <img 
                                                        style={{width:40, height:40, borderRadius:'50%', objectFit:'cover'}}
                                                        src={userInfo.Profile}
                                                        alt={userInfo.Full_Name || 'User'}
                                                        onError={() => setProfileImageError(true)}
                                                    />
                                                ) : (
                                                    <div style={{
                                                        width:40, height:40, borderRadius:'50%', backgroundColor:'#673ab7',
                                                        display:'flex', alignItems:'center', justifyContent:'center',
                                                        color:'white', fontWeight:'bold', fontSize:16
                                                    }}>
                                                        {(userInfo.Full_Name || userInfo.Email || 'U').charAt(0).toUpperCase()}
                                                    </div>
                                                )}
                                                <div>
                                                    <div style={{fontWeight:600, fontSize:16, color:'#333', marginBottom:1}}>
                                                        {userInfo.Full_Name || 'User'}
                                                    </div>
                                                    <div>
                                                        <span style={{
                                                            display:'inline-block',
                                                            padding:'3px 10px',
                                                            borderRadius:9999,
                                                            background:'#ede7f6',
                                                            color:'#5e35b1',
                                                            fontSize:11,
                                                            fontWeight:700,
                                                            textTransform:'uppercase',
                                                            letterSpacing:'0.4px'
                                                        }}>
                                                            {userInfo.Role || 'User'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Member Since */}
                                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#666', fontSize:12, fontWeight:500}}>
                                                    <EventNoteIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                    Member since
                                                </span>
                                                <span style={{color:'#333', fontSize:13, fontWeight:600}}>
                                                    {(() => {
                                                        const raw = userInfo?.Member_Since || userInfo?.memberSince || userInfo?.Created_At || userInfo?.createdAt || firebaseAuth.currentUser?.metadata?.creationTime;
                                                        if (!raw) return '—';
                                                        const d = new Date(raw);
                                                        if (isNaN(d)) {
                                                            const s = String(raw);
                                                            return s.length > 16 ? s.slice(0,16) + '…' : s;
                                                        }
                                                        return d.toLocaleDateString();
                                                    })()}
                                                </span>
                                            </div>

                                            {/* Email Row */}
                                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                    <EmailIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                    {userInfo.Email || userInfo.email || firebaseAuth.currentUser?.email || '—'}
                                                </span>
                                                {(() => {
                                                    const emailVerified = (userInfo?.emailVerified === true) || (userInfo?.Email_Verified === true) || (firebaseAuth.currentUser?.emailVerified === true);
                                                    return (
                                                    <span style={{
                                                        display:'inline-block',
                                                        padding:'3px 10px',
                                                        borderRadius:9999,
                                                        fontSize:11, fontWeight:700,
                                                        background: emailVerified ? 'rgba(76,175,80,0.12)' : 'rgba(244,67,54,0.12)',
                                                        color: emailVerified ? '#2e7d32' : '#c62828',
                                                        textTransform:'uppercase', letterSpacing:'0.4px'
                                                    }}>
                                                        {emailVerified ? 'Verified' : 'Not Verified'}
                                                    </span>
                                                    );
                                                })()}
                                            </div>

                                            {/* Phone Row */}
                                            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                    <PhoneIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                    {userInfo.Mobile_No || userInfo.mobile || userInfo.Phone_Number || '—'}
                                                </span>
                                                {(() => {
                                                    const mobileVerified = (userInfo?.mobileVerified === true) || (userInfo?.Mobile_Verified === true);
                                                    return (
                                                    <span style={{
                                                        display:'inline-block',
                                                        padding:'3px 10px',
                                                        borderRadius:9999,
                                                        fontSize:11, fontWeight:700,
                                                        background: mobileVerified ? 'rgba(76,175,80,0.12)' : 'rgba(244,67,54,0.12)',
                                                        color: mobileVerified ? '#2e7d32' : '#c62828',
                                                        textTransform:'uppercase', letterSpacing:'0.4px'
                                                    }}>
                                                        {mobileVerified ? 'Verified' : 'Not Verified'}
                                                    </span>
                                                    );
                                                })()}
                                            </div>

                                            {/* GST Row (retailers only) */}
                                            {(userInfo.Role && String(userInfo.Role).toLowerCase() === 'retailer') && (userInfo.Business_Proof_Type || userInfo.Business_Proof_No || userInfo.Business_Proof_Image) && (
                                                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                    <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                        <AssignmentIndIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                        {(userInfo.Business_Proof_Type || '').toString().toUpperCase() || 'GST'} - {userInfo.Business_Proof_No || '—'}
                                                    </span>
                                                    {userInfo.Business_Proof_Image && (
                                                        <a 
                                                            href={userInfo.Business_Proof_Image}
                                                            target="_blank" 
                                                            rel="noreferrer" 
                                                            style={{
                                                                textDecoration:'none',
                                                                display:'inline-block',
                                                                padding:'3px 10px',
                                                                borderRadius:9999,
                                                                background:'#673ab7',
                                                                color:'#ffffff',
                                                                fontSize:11,
                                                                fontWeight:700,
                                                                textTransform:'uppercase',
                                                                letterSpacing:'0.4px'
                                                            }}
                                                        >
                                                            View
                                                        </a>
                                                    )}
                                                </div>
                                            )}

                                            {/* Additional Details for Retailers */}
                                            {(userInfo.Role && String(userInfo.Role).toLowerCase() === 'retailer') && (
                                                <>
                                                    {/* Business Verified Row */}
                                                    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                        <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#666', fontSize:12, fontWeight:500}}>
                                                            <VerifiedUserIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                            Business status
                                                        </span>
                                                        <span style={{
                                                            fontSize:12, fontWeight:700,
                                                            color: (userInfo.isVerifiedBusiness ? '#4caf50' : '#f44336')
                                                        }}>
                                                            {userInfo.isVerifiedBusiness ? 'Verified' : 'Not Verified'}
                                                        </span>
                                                    </div>
                                                    {/* Shop Name */}
                                                    {userInfo.Shop_Name && (
                                                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                            <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                                <StorefrontIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                                Shop: {userInfo.Shop_Name}
                                                            </span>
                                                        </div>
                                                    )}
                                                    
                                                    {/* Business Address */}
                                                    {userInfo.Business_Address && (
                                                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                            <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                                <HomeIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                                Address: {userInfo.Business_Address}
                                                            </span>
                                                        </div>
                                                    )}
                                                    
                                                    {/* City */}
                                                    {userInfo.City && (
                                                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                            <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                                <LocationCityIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                                City: {userInfo.City}
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                            {/* Additional Details for Regular Users */}
                                            {(!userInfo.Role || String(userInfo.Role).toLowerCase() === 'user') && (
                                                <>
                                                    {/* Address */}
                                                    {userInfo.Address && (
                                                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                            <span style={{display:'inline-flex', alignItems:'center', gap:6, color:'#333', fontSize:14}}>
                                                                <HomeIcon style={{fontSize:16, color:'#9e9e9e'}} />
                                                                Address: {userInfo.Address}
                                                            </span>
                                                        </div>
                                                    )}
                                                    
                                                    {/* City */}
                                                    {userInfo.City && (
                                                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'3px 0'}}>
                                                            <span style={{color:'#333', fontSize:14}}>
                                                                City: {userInfo.City}
                                                            </span>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        
                                        <div className="profile-dropdown-divider"></div>
                                        
                                        {/* Quick Menu Links */}
                                        <div className="profile-menu">
                                            <Link to="/profile" className="profile-menu-item">
                                                <span className="profile-menu-icon"><PersonOutlineIcon fontSize="small" /></span>
                                                <span>Profile</span>
                                            </Link>
                                            <Link to="/orders" className="profile-menu-item">
                                                <span className="profile-menu-icon"><ListAltIcon fontSize="small" /></span>
                                                <span>Orders</span>
                                            </Link>
                                            <Link to="/returns" className="profile-menu-item">
                                                <span className="profile-menu-icon"><AssignmentReturnIcon fontSize="small" /></span>
                                                <span>Returns</span>
                                            </Link>
                                            <Link to="/cart" className="profile-menu-item">
                                                <span className="profile-menu-icon"><ShoppingCartIcon style={{fontSize: 18}} /></span>
                                                <span>Cart</span>
                                            </Link>
                                            <Link to="/rewards" className="profile-menu-item">
                                                <span className="profile-menu-icon"><LoyaltyIcon fontSize="small" /></span>
                                                <span>Rewards</span>
                                            </Link>
                                            <Link to="/wishlist" className="profile-menu-item">
                                                <span className="profile-menu-icon"><FavoriteBorderIcon fontSize="small" /></span>
                                                <span>Wishlist</span>
                                            </Link>
                                            <Link to="/notifications" className="profile-menu-item">
                                                <span className="profile-menu-icon"><NotificationsNoneIcon fontSize="small" /></span>
                                                <span>Notifications</span>
                                            </Link>
                                        </div>

                                        <div className="profile-action-section">
                                            <button className="profile-action-btn primary" onClick={signoutHandler}>
                                                Logout
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <Link to="/signin">
                                <span className='header__optionLineTwo'>
                                    Sign In
                                </span>
                            </Link>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default Header
